// 供需与发布：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动线索
export const mobileClue = Object.freeze({
  "mobileClue.searchPlaceholder": "请在此输入搜索关键词",
  "mobileClue.noData": "暂无数据",
  "mobileClue.supplyPublished": "货源发布成功！",
  "mobileClue.demandPublished": "需求发布成功！",
  "mobileClue.supplyReviewHint": "货源信息审核通过后，即可分配谈判人",
  "mobileClue.demandReviewHint": "需求信息审核通过后，即可分配谈判人",
  "mobileClue.backHome": "返回首页",
  "mobileClue.searchPartOrName": "搜索料号、名称",
  "mobileClue.search": "搜索",
  "mobileClue.listEnd": "我们是有底线的",
  "mobileClue.supply": "货源",
  "mobileClue.wantToBuy": "求购",
});

// 批量发布
export const batchPublish = Object.freeze({
  "pcBatch.title": "批量导入",
  "pcBatch.supply": "批量发布供应",
  "pcBatch.demand": "批量发布需求",
  "pcBatch.uploadTab": "文件上传",
  "pcBatch.drag": "将文件拖到此处，或",
  "pcBatch.clickUpload": "点击上传",
  "pcBatch.limit": "支持 xls/xlsx，单次最多 200 条记录",
  "pcBatch.remove": "移除",
  "pcBatch.import": "导入",
  "pcBatch.downloadTemplate": "下载模板",
  "pcBatch.templateHint":
    "提示：文件将采用程序自动处理，请使用标准模板，以减少转换错误。",
  "pcBatch.maximumBefore": "批量导入每次发布上限",
  "pcBatch.maximumAfter": "条。",
  "pcBatch.result": "导入结果",
  "pcBatch.clear": "清除",
  "pcBatch.successCount": "成功：{count} 条；",
  "pcBatch.failureCount": "失败：{count} 条",
  "pcBatch.excelOnly": "仅支持上传 Excel 文件（.xls/.xlsx）。",
  "pcBatch.chooseFile": "请先选择 Excel 文件。",
  "pcBatch.importSuccess": "导入成功",
  "pcBatch.importFailed": "导入失败，请重试",
  "pcBatch.networkOrFileError": "导入失败，请检查网络或文件内容",
});

// 桌面线索
export const desktopClue = Object.freeze({
  "pcClue.searchPlaceholder": "搜索料号、名称",
  "pcClue.productType": "产品类型：",
  "pcClue.productBrand": "产品品牌：",
  "pcClue.goodsLocationLabel": "货所在地：",
  "pcClue.goodsCondition": "货物情况：",
  "pcClue.all": "全部",
  "pcClue.expand": "展开",
  "pcClue.collapse": "收起",
  "pcClue.publish": "供求发布",
  "pcClue.manage": "管理",
  "pcClue.supply": "供应",
  "pcClue.demand": "需求",
  "pcClue.buy": "求购",
  "pcClue.wide": "宽",
  "pcClue.narrow": "窄",
  "pcClue.card": "卡片",
  "pcClue.list": "列表",
  "pcClue.endOfList": "我们是有底线的",
  "pcClue.loadFailed": "获取数据失败，请重新加载",
  "pcClue.type": "类型",
  "pcClue.partNumber": "料号",
  "pcClue.brand": "品牌",
  "pcClue.category": "分类",
  "pcClue.location": "所在地",
  "pcClue.currency": "货币",
  "pcClue.usd": "美元",
  "pcClue.cny": "人民币",
  "pcClue.price": "价格",
  "pcClue.quantity": "数量",
  "pcClue.batch": "批次",
  "pcClue.condition": "货态",
  "pcClue.originalManufacturer": "原厂",
  "pcClue.deliveryTime": "交货时间",
  "pcClue.days": "{count}天",
  "pcClue.undetermined": "未定",
  "pcClue.publishedAt": "发布时间",
  "pcClue.publisher": "发布人",
  "pcClue.brandNew": "全新",
  "pcClue.stock": "库存",
  "pcClue.demandQuantity": "需求量",
  "pcClue.minimumOrder": "起订",
  "pcClue.deposit": "保证金",
  "pcClue.region": "地区",
  "pcClue.bidDeadline": "截标",
  "pcClue.bidOpening": "开标",
  "pcClue.fiveSuppliers": "5家",
  "pcClue.selectedCount": "已选择 {count} 项",
  "pcClue.delete": "删除",
  "pcClue.review": "审核",
  "pcClue.monthDay": "{month}月{day}日",
  "pcClue.brand.skHynix": "海力士",
  "pcClue.brand.samsung": "三星",
  "pcClue.brand.micron": "美光",
  "pcClue.brand.infineon": "英飞凌",
  "pcClue.brand.nxp": "恩智浦",
  "pcClue.brand.st": "意法半导体",
  "pcClue.brand.ti": "德州仪器",
  "pcClue.brand.espressif": "乐鑫",
  "pcClue.brand.gigaDevice": "兆易创新",
  "pcClue.brand.winbond": "华邦",
  "pcClue.brand.nanya": "南亚",
  "pcClue.brand.broadcom": "博通",
  "pcClue.brand.qualcomm": "高通",
  "pcClue.brand.mediatek": "联发科",
  "pcClue.hongKong": "香港",
  "pcClue.domestic": "国内",
  "pcClue.bondedArea": "保税区",
  "pcClue.other": "其他",
  "pcClue.originalCarton": "原箱",
  "pcClue.genuine": "原装",
  "pcClue.originalPackage": "原包",
  "pcClue.originalLabel": "原标",
});

// 货源发布
export const sourcePublish = Object.freeze({
  "sourcePublish.ownerInfo": "货主信息",
  "sourcePublish.iAmOwner": "我是货主",
  "sourcePublish.contact": "联系人",
  "sourcePublish.enterContact": "请填写联系人",
  "sourcePublish.required": "不能为空",
  "sourcePublish.ms": "女士",
  "sourcePublish.mr": "先生",
  "sourcePublish.contactMethod": "联系方式",
  "sourcePublish.enterMobile": "请填写手机号",
  "sourcePublish.wechat": "微信",
  "sourcePublish.enterWechat": "请填写微信号",
  "sourcePublish.hometown": "籍贯",
  "sourcePublish.enterHometown": "请填写籍贯",
  "sourcePublish.personality": "性格",
  "sourcePublish.hobbies": "爱好",
  "sourcePublish.remarks": "备注",
  "sourcePublish.ownerRemarks": "请填写货主信息备注",
  "sourcePublish.productInfo": "产品信息",
  "sourcePublish.productLink": "商品id/链接",
  "sourcePublish.enterProductLink": "请填写供需频道id或链接",
  "sourcePublish.images": "图片",
  "sourcePublish.imageHint": "拖拽排序，双击查看图片",
  "sourcePublish.uploadProductImages": "上传产品图片",
  "sourcePublish.productName": "产品名称",
  "sourcePublish.enterProductName": "请填写产品名称",
  "sourcePublish.brand": "品牌",
  "sourcePublish.enterBrand": "请填写品牌名称",
  "sourcePublish.selectBrand": "选择品牌",
  "sourcePublish.partNumber": "规格料号",
  "sourcePublish.enterPartNumber": "请填写规格料号",
  "sourcePublish.manufactureDate": "生产日期（DC）",
  "sourcePublish.selectManufactureDate": "请选择生产日期",
  "sourcePublish.unitPrice": "单价",
  "sourcePublish.enterPrice": "请输入单价",
  "sourcePublish.quantity": "数量",
  "sourcePublish.enterQuantity": "请输入数量",
  "sourcePublish.unit": "单位",
  "sourcePublish.enterUnit": "请输入单位",
  "sourcePublish.stockLocation": "货所在地",
  "sourcePublish.enterStockLocation": "请填写货所在地",
  "sourcePublish.batch": "批次(DC)",
  "sourcePublish.enterBatch": "请填写批次",
  "sourcePublish.condition": "货物情况",
  "sourcePublish.category": "产品分类",
  "sourcePublish.selectCategory": "请选择产品分类",
  "sourcePublish.noAttributes": "暂无分类属性，请选择二级分类",
  "sourcePublish.moreInfo": "补充信息",
  "sourcePublish.datasheet": "规格书",
  "sourcePublish.uploadDatasheet": "上传规格书",
  "sourcePublish.originProof": "原产地证明",
  "sourcePublish.uploadProof": "上传证明",
  "sourcePublish.manufacturer": "厂家",
  "sourcePublish.enterManufacturer": "请填写厂家",
  "sourcePublish.weight": "重量",
  "sourcePublish.enterWeight": "请填写重量",
  "sourcePublish.gram": "克",
  "sourcePublish.dimensions": "尺寸",
  "sourcePublish.length": "长",
  "sourcePublish.width": "宽",
  "sourcePublish.height": "高",
  "sourcePublish.enterLength": "请填写长度",
  "sourcePublish.enterWidth": "请填写宽度",
  "sourcePublish.enterHeight": "请填写高度",
  "sourcePublish.millimeter": "毫米",
  "sourcePublish.substitutes": "替代",
  "sourcePublish.applications": "应用",
  "sourcePublish.tagHint": "（用空格或者逗号分开，按回车确认）",
  "sourcePublish.minimumOrder": "起订量",
  "sourcePublish.enterMinimumOrder": "请填写起订量",
  "sourcePublish.validity": "有效期",
  "sourcePublish.selectValidity": "请选择有效期",
  "sourcePublish.deliveryDays": "交货天数",
  "sourcePublish.enterDeliveryDays": "请填写预计交货天数",
  "sourcePublish.workingDays": "工作日",
  "sourcePublish.ownerCompany": "货主公司",
  "sourcePublish.enterOwnerCompany": "请填写货主公司名称",
  "sourcePublish.productRemarks": "请填写产品信息备注",
  "sourcePublish.informationProvider": "信息提供人",
  "sourcePublish.anonymous": "匿名",
  "sourcePublish.assignedNegotiator": "指定谈判人",
  "sourcePublish.enterAssignedMobile": "请填写指定谈判人手机号",
  "sourcePublish.saveDraft": "暂存",
  "sourcePublish.notAvailable": "暂未开放",
  "sourcePublish.buyerInfo": "买家信息",
  "sourcePublish.iAmBuyer": "我是买家",
  "sourcePublish.deliveryAddress": "交货地址",
  "sourcePublish.enterDeliveryAddress": "请填写交货地址",
  "sourcePublish.buyerRemarks": "请填写买家信息备注",
  "sourcePublish.demandInfo": "需求信息",
  "sourcePublish.targetPrice": "期望价格",
  "sourcePublish.enterTargetPrice": "请填写期望价格",
  "sourcePublish.enterPurchaseQuantity": "请填写购买数量",
  "sourcePublish.recommendedNegotiator": "推荐谈判人",
  "sourcePublish.enterRecommendedMobile": "请填写推荐谈判人手机号",
  "sourcePublish.searchCategory": "请输入分类名称搜索",
  "sourcePublish.select": "请选择",
  "sourcePublish.enter": "请输入",
  "sourcePublish.confirm": "确定",
  "sourcePublish.chipSpecs": "芯片规格",
  "sourcePublish.package": "封装",
  "sourcePublish.batchShort": "批次",
  "sourcePublish.submit": "提交",
  "sourcePublish.selectDate": "选择年月日",
  "sourcePublish.bulkUpload": "批量上传供需信息",
  "sourcePublish.cancel": "取消",
  "sourcePublish.confirmPost": "确认发布",
  "sourcePublish.postSupply": "发布货源",
  "sourcePublish.postSupplyLead": "发布货源线索",
  "sourcePublish.postSupplyHint": "填写货源信息，发布货源线索",
  "sourcePublish.postDemand": "发布需求",
  "sourcePublish.postDemandLead": "发布需求线索",
  "sourcePublish.postDemandHint": "填写需求信息，发布需求线索",
  "sourcePublish.submitPurchaseIntent": "提交购买意向单",
  "sourcePublish.datasheetAttachment": "规格书附件",
  "sourcePublish.cny": "人民币",
  "sourcePublish.usd": "美元",
  "sourcePublish.loginFirst": "请先登录",
  "sourcePublish.requiredField": "必填项",
  "sourcePublish.validNumber": "请填写有效的数字",
  "sourcePublish.postSuccess": "发布成功",
  "sourcePublish.failed": "失败",
  "sourcePublish.completeForm": "请填写完整信息！",
  "sourcePublish.draftSaved": "内容暂存成功！",
  "sourcePublish.uploading": "上传中...",
  "sourcePublish.uploadSuccess": "上传成功",
  "sourcePublish.uploadFailed": "上传失败",
  "sourcePublish.chooseUpload": "请选择要上传的文件",
  "sourcePublish.waitUpload": "文件上传中，请等待上传完成",
  "sourcePublish.importSuccess": "导入成功",
  "sourcePublish.importFailed": "导入失败",
  "sourcePublish.approximately": "约",
  "sourcePublish.maxTags": "最多只能添加{count}个标签",
  "sourcePublish.purchaseIntentSuccess": "提交订购意向成功！请等待谈判人接单！",
  "sourcePublish.enterAlternativeBrand": "请填写替代品牌",
  "sourcePublish.model": "料号",
  "sourcePublish.enterAlternativeModel": "请填写替代料号",
  "sourcePublish.originProofFile": "原产地证明{count}",
});

// 供需详情
export const detail = Object.freeze({
  "supplyDetail.supplyDetails": "供应详情",
  "supplyDetail.demandDetails": "需求详情",
  "supplyDetail.stockSupply": "现货供应",
  "supplyDetail.wanted": "求购需求",
  "supplyDetail.inventoryQuantity": "库存数量",
  "supplyDetail.demandQuantity": "需求数量",
  "supplyDetail.minimumOrder": "起订量",
  "supplyDetail.warehouseSource": "仓库/货源地",
  "supplyDetail.deliveryPeriod": "交付周期",
  "supplyDetail.validity": "有效期",
  "supplyDetail.publisher": "发布公司",
  "supplyDetail.inquire": "马上询价",
  "supplyDetail.quote": "我要报价",
  "supplyDetail.companyInfo": "企业信息",
  "supplyDetail.contactName": "联系人",
  "supplyDetail.contactPhone": "联系电话",
  "supplyDetail.contactNotice": "联系信息以平台认证资料和后端返回为准",
  "supplyDetail.details": "详细信息",
  "supplyDetail.partNumber": "料号",
  "supplyDetail.specifications": "规格参数",
  "supplyDetail.condition": "货物情况",
  "supplyDetail.application": "应用场景",
  "supplyDetail.replacements": "替代料号",
  "supplyDetail.productionDate": "生产日期",
  "supplyDetail.tradeNotes": "交易说明",
  "supplyDetail.emptyNotes": "暂无补充说明",
  "supplyDetail.publication": "发布信息",
  "supplyDetail.publishedAt": "发布时间",
  "supplyDetail.status": "状态",
  "supplyDetail.infoType": "供需类型",
  "supplyDetail.notFound": "未找到该供需信息，可能已下架",
  "supplyDetail.backHall": "返回供需大厅",
  "supplyDetail.backList": "返回列表",
  "supplyDetail.longTerm": "长期有效",
  "supplyDetail.validRange": "{from} 至 {to}",
  "supplyDetail.loadFailed": "加载供需详情失败，请重试",
  "supplyDetail.inquiryPending": "询价功能开发中...",
  "supplyDetail.quotePending": "报价功能开发中...",
  "supplyDetail.status.pending": "待审核",
  "supplyDetail.status.approved": "已审核",
  "supplyDetail.status.published": "已发布",
  "supplyDetail.status.offline": "已下架",
});

// 供需大厅
export const hall = Object.freeze({
  "supplyHall.title": "供需大厅",
  "supplyHall.intro": "集中查看供应和需求信息，支持快速筛选、收藏和详情跟进。",
  "supplyHall.services": "供需服务",
  "supplyHall.serviceHint": "发布供求信息或完善企业资料",
  "supplyHall.postSupply": "发布供应",
  "supplyHall.postDemand": "发布需求",
  "supplyHall.join": "企业入驻",
  "supplyHall.productType": "产品类型：",
  "supplyHall.originalDescription": "原文（简体中文）",
  "supplyHall.productBrand": "产品品牌：",
  "supplyHall.any": "不限",
  "supplyHall.expand": "展开",
  "supplyHall.collapse": "收起",
  "supplyHall.search": "搜索",
  "supplyHall.all": "全部",
  "supplyHall.supply": "供应",
  "supplyHall.demand": "需求",
  "supplyHall.wanted": "求购",
  "supplyHall.brandPartPlaceholder": "品牌、料号",
  "supplyHall.quantity": "数量",
  "supplyHall.cards": "卡片",
  "supplyHall.table": "表格",
  "supplyHall.uncategorized": "未分类",
  "supplyHall.stock": "库存",
  "supplyHall.demandQuantity": "需求量",
  "supplyHall.minimumOrder": "起订",
  "supplyHall.delivery": "交付",
  "supplyHall.viewDetails": "查看详情",
  "supplyHall.details": "详情",
  "supplyHall.type": "类型",
  "supplyHall.partNumber": "料号",
  "supplyHall.brand": "品牌",
  "supplyHall.category": "分类",
  "supplyHall.price": "价格",
  "supplyHall.location": "所在地",
  "supplyHall.action": "操作",
  "supplyHall.mainland": "大陆",
  "supplyHall.hongKong": "香港",
  "supplyHall.empty": "暂无相关供需信息",
  "supplyHall.total": "共 {count} 条",
  "supplyHall.searchBrand": "搜索品牌",
  "supplyHall.brandPlaceholder": "请输入品牌名称",
  "supplyHall.searching": "搜索中...",
  "supplyHall.noBrand": "未找到匹配的品牌",
  "supplyHall.cancel": "取消",
  "supplyHall.confirm": "确定",
  "supplyHall.loadFailed": "加载供需大厅失败，请重试",
  "supplyHall.days": "{count}天",
  "supplyHall.chooseBrand": "请选择品牌",
  "supplyHall.realnameNotice":
    "《网络安全法》规定，实名才可发布信息，前往实名认证！",
  "supplyHall.notice": "温馨提示",
  "supplyHall.goRealname": "前往实名认证",
  "supplyHall.joinSuccess": "企业入驻成功",
  "supplyHall.joinFailed": "企业入驻失败",
  "supplyHall.unfavorited": "已取消收藏",
  "supplyHall.published": "已发布",
  "supplyHall.favorited": "收藏成功",
  "supplyHall.tenThousands": "{count}万",
});

// 供需发布
export const publish = Object.freeze({
  "pcPublish.supplyTitle": "供应发布",
  "pcPublish.demandTitle": "需求发布",
  "pcPublish.category": "分类",
  "pcPublish.brand": "品牌",
  "pcPublish.partNumber": "料号",
  "pcPublish.unitPrice": "单价",
  "pcPublish.quantity": "数量",
  "pcPublish.batch": "批次",
  "pcPublish.parameters": "参数",
  "pcPublish.tradeNotes": "交易说明(备注)",
  "pcPublish.selectFromList": "请从列表中选择",
  "pcPublish.searchAndSelect": "输入关键词搜索并选择",
  "pcPublish.enterPartNumber": "请输入料号",
  "pcPublish.enterValue": "请输入",
  "pcPublish.enterText": "请输入文字",
  "pcPublish.yuan": "元",
  "pcPublish.confirm": "确认发布",
  "pcPublish.searchCategory": "搜索分类",
  "pcPublish.searchBrand": "搜索品牌",
  "pcPublish.categoryResult": "共搜索到 {count} 条与“{keyword}”相关的信息",
  "pcPublish.brandCount": "共 {count} 条品牌",
  "pcPublish.noSubcategory": "该分类暂无二级分类，可直接选择父级",
  "pcPublish.chooseCategory": "选择该分类",
  "pcPublish.chooseBrand": "选择品牌",
  "pcPublish.categoryRequired": "请选择分类！",
  "pcPublish.brandRequired": "请选择品牌！",
  "pcPublish.partNumberRequired": "请输入料号！",
  "pcPublish.priceRequired": "请输入单价！",
  "pcPublish.quantityRequired": "请输入数量！",
  "pcPublish.success": "发布成功！",
  "pcPublish.failed": "发布失败，请重试！",
  "pcPublish.networkFailed": "发布失败，请检查网络连接后重试！",
  "pcPublish.images": "图片",
  "pcPublish.uploadImage": "上传图片",
  "pcPublish.categoryHint": "请选择全站分类",
  "pcPublish.brandHint": "搜索并选择品牌",
  "pcPublish.partNumberHint": "输入料号，可搜索选择",
  "pcPublish.specification": "规格",
  "pcPublish.specificationHint": "请输入规格",
  "pcPublish.title": "标题名称",
  "pcPublish.supplyTitleHint": "可按货源所在地、供应、料号、数量和替代信息填写",
  "pcPublish.demandTitleHint": "可按货源所在地、需求、料号、数量和替代信息填写",
  "pcPublish.currency": "币种",
  "pcPublish.chooseCurrency": "请选择币种",
  "pcPublish.currencyCNY": "CNY - 人民币",
  "pcPublish.currencyUSD": "USD - 美元",
  "pcPublish.currencyEUR": "EUR - 欧元",
  "pcPublish.currencyGBP": "GBP - 英镑",
  "pcPublish.currencyJPY": "JPY - 日元",
  "pcPublish.currencyHKD": "HKD - 港币",
  "pcPublish.unit": "单位",
  "pcPublish.minimumOrder": "起订量",
  "pcPublish.manufactureDate": "生产日期",
  "pcPublish.chooseDate": "请选择生产日期",
  "pcPublish.origin": "货源所在地",
  "pcPublish.enterOrigin": "请输入货源所在地",
  "pcPublish.validity": "有效期",
  "pcPublish.chooseValidity": "请选择有效期",
  "pcPublish.longTerm": "长期有效",
  "pcPublish.deliveryDays": "交货天数",
  "pcPublish.applications": "应用",
  "pcPublish.tagsHint": "输入标签，使用空格或逗号分隔",
  "pcPublish.alternatives": "替代",
  "pcPublish.chooseBrandHint": "请选择品牌",
  "pcPublish.size": "尺寸",
  "pcPublish.length": "长",
  "pcPublish.width": "宽",
  "pcPublish.height": "高",
  "pcPublish.millimeter": "毫米",
  "pcPublish.weight": "重量",
  "pcPublish.gram": "克",
  "pcPublish.ownerCompany": "货主公司名称",
  "pcPublish.defaultCompany": "默认会员公司名称",
  "pcPublish.datasheet": "上传规格书",
  "pcPublish.notes": "备注",
  "pcPublish.notesHint": "请输入备注说明",
  "pcPublish.preview": "发布预览",
  "pcPublish.selectAlternativeBrand": "选择替代品牌",
  "pcPublish.previewUnavailable": "预览功能开发中...",
  "pcPublish.imageRequired": "请上传图片！",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "supplyForm.awaitingContact": "待接待",
  "supplyForm.negotiatorAccepted": "谈判人已接单",
  "supplyForm.businessAccepted": "商务已接单",
  "supplyForm.contractCreated": "已生成合同",
  "supplyForm.confirmAmount": "确认金额",
  "supplyForm.buyerPaid": "买家已支付",
  "supplyForm.sellerPaid": "货主已支付",
  "supplyForm.reviewTitle": "信息审核",
  "supplyForm.editSupplyLead": "修改货源线索",
  "supplyForm.enterPrice": "请输入价格",
  "supplyForm.completeSupply": "谈判人完善货源信息",
  "supplyForm.uploadImage": "请上传商品图片",
  "supplyForm.completeBeforeSave": "请填写完整信息后再保存数据！",
  "supplyForm.bulk": "大宗",
  "supplyForm.searchableTitle": "标题有助于搜索",
  "supplyForm.enterField": "请填写",
  "supplyForm.enterCondition": "请填写货物情况",
  "supplyForm.enterPackageType": "请填写封装类型",
  "supplyForm.enterChipType": "请填写芯片类型",
  "supplyForm.enterUnitPrice": "请填写单价",
  "supplyForm.enterProductTitle": "请填写产品标题",
  "supplyForm.notRegistered": "（未入驻）",
  "supplyForm.saveNext": "保存并下一步",
  "supplyForm.savePublish": "保存并发布货源",
  "supplyForm.currentStatusPrefix": "当前状态：",
  "supplyForm.negotiatorPrefix": "谈判人：",
  "supplyForm.pdfRequired": "请上传PDF文件",
  "supplyForm.pricePositive": "价格必须大于0",
  "supplyForm.quantityPositive": "数量必须大于0",
  "supplyForm.reviewConfirm": "是否审核这条数据？",
  "supplyForm.deleteConfirm": "确定要删除这条线索吗？",
  "supplyForm.dimensionsMm": "{dimensions} 毫米",
  "supplyForm.deliveryWorkdays": "{days} 工作日",
  "supplyForm.approximateConversion": "（约 {amount} {unit}）",
  "supplyForm.editInformation": "编辑信息",
  "supplyForm.enterSupplier": "请填写供应商",
  "supplyForm.enterProductType": "请填写产品类型",
  "supplyForm.enterArchitecture": "请填写架构",
  "supplyForm.enterSpeed": "请填写速率",
  "supplyForm.enterBall": "请填写球位",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const publishDisplayFollowup = Object.freeze({
  "publishDisplay.bulk": "大宗",
  "publishDisplay.postSupply": "发布货源",
  "publishDisplay.postDemand": "发布需求",
  "publishDisplay.hasOriginProof": "有原产地证明",
  "publishDisplay.noOriginProof": "无原产地证明",
  "publishDisplay.unknownOriginProof": "不了解",
  "publishDisplay.tagExample":
    "例：品类一,品类二,品类三 或 品类一 品类二 品类三",
  "publishDisplay.computers": "电脑",
  "publishDisplay.phones": "手机",
  "publishDisplay.automotive": "汽车",
  "publishDisplay.iot": "物联网",
  "publishDisplay.networks": "网络",
});

export const messages = Object.freeze({
  ...publishDisplayFollowup,
  ...mobileWorkflow,
  ...mobileClue,
  ...batchPublish,
  ...desktopClue,
  ...sourcePublish,
  ...detail,
  ...hall,
  ...publish,
});
